import { BM_GTM_CONTAINER_ID, BM_GTM_SERVER_URL } from "@util/Config";
import { logError } from "@util/sentry-error";

declare global {
	interface Window {
		gtag: (...args: unknown[]) => void;
	}
}

let injected = false;

// The BODY noscript fallback is intentionally absent: JS-injected noscript can never run without JS.
export function initGtm(): void {
	if (injected) {
		return;
	}

	// The container is configured per environment, so a missing value would turn measurement off
	// for a whole environment with no other symptom. Report it instead of returning quietly.
	if (!BM_GTM_CONTAINER_ID || !BM_GTM_SERVER_URL) {
		logError(new Error("GTM is not configured: BM_GTM_CONTAINER_ID or BM_GTM_SERVER_URL is empty"));

		return;
	}

	window.dataLayer = window.dataLayer || [];

	// Queues gtag commands on the dataLayer, as the public site's snippet does. Consent Mode calls
	// gtag("consent", ...) before gtag.js itself loads, so this has to exist before the container
	// script is inserted, and it has to forward the raw arguments object.
	window.gtag = function gtag() {
		// biome-ignore lint/style/noArguments: the gtag contract is to push the arguments object itself
		window.dataLayer.push(arguments);
	};

	window.dataLayer.push({
		"gtm.start": Date.now(),
		event: "gtm.js",
	});

	const script = document.createElement("script");
	script.async = true;
	script.src = `${BM_GTM_SERVER_URL}/gtm.js?id=${BM_GTM_CONTAINER_ID}`;
	script.setAttribute("data-bm-gtm", "");
	document.head.appendChild(script);

	injected = true;
}
